import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import cn from 'classnames';
import _ from 'lodash';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { AppClientId } from '../../Shared/constants';
import { REQUEST_USER } from '../../Users/constants';
import { fetchUser } from '../../Users/actions';
import { selectUser } from '../../Users/selectors';
import { selectWorks, selectPermissions } from '../../Api/selectors';
import { REQUEST_VEHICLE_PROPERTY_UPDATE, VEHICLE_EXTRA_COST } from '../constants';
import { deleteVehicleProperty, setVehicleProperty } from '../actions';

import { HBox, VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { FormField } from '../../../components/FormFields';
import { Loader } from '../../../components/Loader';
import { Cell, List, Row } from '../../../components/List';
import { IsOpen, Plus, TimesSquare, Check, Euro, Times } from '../../../components/Icon';
import { BaseComponent } from 'components/BaseComponent';
import { getPropByName } from '../../../utils/props';
import { formatCurrency } from '../../../utils/string';

import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';

import env from '../../../env';
import styles from './CardExtraCost.module.css';
import { VehiclePropertyLoadable } from './VehiclePropertyLoadable';
import {
  DEP_FINANCE,
  DEP_COMMERCE,
  DEP_WALSTREET,
  DEP_ADMINISTRATION,
  DEP_IT,
  DEP_WORKSHOP,
  DEP_ADMIN,
  DEP_TRANSPORT,
} from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';
import { hasPermissions } from '../../../utils/helpers/permissions';

dayjs.extend(customParseFormat);


const Container = styled.div`
  width: 100%;
  .sum {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 15px;
  }
  .vehicle-property-loadable {
    .label {
      margin-right: auto;
      margin-left: 10px;
    }

    .form-controlField {
      margin-bottom: 0;
    }
    .value {
      width: 90px;
    }
    width: 100%;
    padding: 5px;
    border-bottom: 1px solid #ddd;
    .formField {
      width: auto;
      margin: 0;
    }
    input {
      width: 90px;
    }
  }

  .remark {
    margin-bottom: 10px;
    min-height: 60px;

    .text {
      width: 85%;
      text-align: start;
    }
  }
`;

const STATE = {
  edit: false,
  add: false,
  amount: '',
  isOpen: false,
  remarks: [],
  newRemarkText: '',
  editableRemark: null,
};
/* eslint-disable react/prefer-stateless-function */
class VehicleExtraCostCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {

    if (hasPermissions(this.props.permissions, DEP_COMMERCE || DEP_ADMINISTRATION || DEP_FINANCE || DEP_WALSTREET || DEP_WORKSHOP || DEP_ADMIN )) {
      this.setState({ isOpen: true });
    }
    this.updateRemarks();
    this.props.fetch();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.vehicle?.extra_costs_remarks !== this.props.vehicle?.extra_costs_remarks ||
      (this.props.vehicle?.extra_costs_remarks && !prevState.edit && this.state.edit)
    ) {
      this.updateRemarks();
    }
  }

  updateRemarks() {
    const { vehicle } = this.props;
    if (vehicle?.extra_costs_remarks) {
      this.setState({ remarks: JSON.parse(vehicle.extra_costs_remarks) });
    }
  }

  reset() {
    this.setState({ ...STATE });
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get vehicleExtraCost() {
    const { additionalCosts } = this.props;
    return additionalCosts ? [...VEHICLE_EXTRA_COST, ...additionalCosts] : VEHICLE_EXTRA_COST;
  }

  onChange(v) {
    this.setState({ selected: v.value });
  }

  get num() {
    return this.vehicleExtraCost?.map(item => this.getStatus(item.name)).filter(a => a).length;
  }

  getStatus(name) {
    return name === 'extra_costs_interest' ? this.vehicle[name] || '0' : this.vehicle[name];
  }

  calc() {
    let sum = _.sumBy(this.vehicleExtraCost, v => {
      let status = this.getStatus(v.name);
      console.log({ name: v.name, status });
      if (status && !isNaN(parseFloat(status))) return parseFloat(status);
      return 0;
    });
    if (parseFloat(sum) != parseFloat(this.vehicle.extra_cost_sum)) {
      const totalSum = sum;
      this.props.add('extra_cost_sum', totalSum);
    }
  }

  removeExtraCost(name) {
    this.setState({ add: null });
    if (this.getStatus(name)) {
      this.props.remove(name, () => {
        this.calc();
        this.onDeleteCostRemark(name);
      });
    }
  }

  toggle(name, amount) {
    const item = this.vehicleExtraCost.find(v => v.name === name);
    const defaultAmount = item?.amount || 1;
    const finalAmount = amount || defaultAmount;
  
    this.setState({ [name]: finalAmount });
    this.props.add(name, parseFloat(finalAmount), this.calc.bind(this));
  
    const remark = this.state.remarks?.find(remark => remark?.cost == name);
    if (remark?.cost) {
      return this.onEditCostRemark(name);
    }
    this.onSaveCostRemark(name);
  }

  get remarkDate() {
    return dayjs(new Date(Date.now())).format('DD-MM-YYYY HH:mm');
  }

  get sortingDate() {
    return new Date(Date.now());
  }

  getFilteredRemarkByExtraCost(extraCost) {
    return this.state.remarks?.find(remark => remark?.cost == extraCost);
  }

  renderInitials(name, surname) {
    return (
      <HBox left vCenter>
        <HBox className={styles.initialsWrapper} vCenter left>
          <strong>{name[0]?.toUpperCase()}</strong>
          <strong>{surname[0]?.toUpperCase()}</strong>
        </HBox>
        &nbsp;
        <strong>{name ?? ''}</strong>
        &nbsp;
        <strong>{surname ?? ''}</strong>
      </HBox>
    );
  }

  resetRemarks() {
    this.setState({ newRemarkText: '', editableRemark: null });
  }

  onSaveCostRemark(extraCost) {
    const remark = {
      cost: extraCost,
      text: this.state.newRemarkText,
      name: getPropByName(this.props.loggedUser, 'name'),
      surname: getPropByName(this.props.loggedUser, 'surname'),
      date: this.remarkDate,
      sortingDate: this.sortingDate,
    };

    if (!remark?.text) {
      return;
    }

    const remarks = [...this.state.remarks, remark];

    this.props.setRemark(JSON.stringify(remarks), result => {
      if (result) {
        this.resetRemarks();
      }
    });
  }

  onEditCostRemark(extraCost) {
    const remark = {
      cost: extraCost,
      text: this.state.newRemarkText,
      name: getPropByName(this.props.loggedUser, 'name'),
      surname: getPropByName(this.props.loggedUser, 'surname'),
      date: this.remarkDate,
      sortingDate: this.sortingDate,
    };

    if (!remark?.text) {
      return;
    }

    const remarks = this.state.remarks?.filter(remark => remark?.cost != extraCost);
    const updatedRemarks = [...remarks, remark];

    this.props.setRemark(JSON.stringify(updatedRemarks));
  }

  onDeleteCostRemark(extraCost) {
    const remarks = this.state.remarks?.filter(remark => remark?.cost != extraCost);
    this.props.setRemark(JSON.stringify(remarks));
    this.resetRemarks();
  }

  getRemarkText(extraCost) {
    const remark = this.getFilteredRemarkByExtraCost(extraCost);
    return remark?.text || '';
  }

  renderCostRemark(extraCost, add = false, readOnly = false) {
    const remark = this.getFilteredRemarkByExtraCost(extraCost);
    const nl2br = text => {
      return { __html: text.replace(/(?:\r\n|\r|\n)/g, '<br>') };
    };
    if (add) {
      return (
        <HBox>
          <FormField vCenter right>
            <input
              type="textarea"
              value={this.state.newRemarkText}
              onChange={e => this.setState({ newRemarkText: e.target?.value })}
            />
          </FormField>
          <div className="icon-cross" onClick={() => this.onDeleteCostRemark(remark?.cost)}>
            <TimesSquare />
          </div>
        </HBox>
      );
    }
    return (
      remark?.cost && (
        <List>
          <Row key={remark?.cost}>
            <div className={styles.remarkCard}>
              {!readOnly && (
                <HBox vCenter right>
                  <div className="icon-cross" onClick={() => this.onDeleteCostRemark(remark?.cost)}>
                    <TimesSquare />
                  </div>
                </HBox>
              )}
              <VBox className="remark" vCenter>
                {remark?.name && remark?.surname && this.renderInitials(remark?.name, remark?.surname)}

                <div className={styles.remarkText}>
                  <h6 dangerouslySetInnerHTML={nl2br(remark?.text)}></h6>
                </div>
              </VBox>
              <HBox right>{remark?.date}</HBox>
            </div>
          </Row>
        </List>
      )
    );
  }

  render() {
    if (this.props.work) return <Loader small />;
    return (
      <Container>
        <Card className={cn('vehicle-info-card info-card data', styles.card)}>
          <HBox>
            {env.clientId === AppClientId.AUTOWIENTJES || env.clientId === AppClientId.AUTOHUISSALLAND ? (
              <h2 className="card-title mb-0 text-muted">{this.lbl('vehicle.property.extra_cost_btw')}</h2>
            ) : (
              <h2 className="card-title mb-0 text-muted">{this.lbl('vehicle.property.extra_cost')}</h2>
            )}


              <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
                <IsOpen />
              </div>
       
          </HBox>

          {(this.state.isOpen) && (
            <VBox>
              <List>

                <Row>
                  <Cell><strong>{this.lbl('vehicle.property.extra_cost_sum')}</strong></Cell>
                  <Cell><strong>{formatCurrency(this.vehicle.extra_cost_sum || '0')}</strong></Cell>
                </Row>

                {this.vehicleExtraCost
                    ?.filter(item => this.vehicle[item.name] != null)
                    .map(item => (
                      <Row key={item.name}>
                        <Cell>
                          {this.lbl(`vehicle.property.${item.name}`)}
                        </Cell>
                        <Cell>
                          {formatCurrency(this.vehicle[item.name] || '0')}
                        </Cell>
                      </Row>
                  ))}

              </List>
              <div className={styles.containerButton}>
                <ButtonComponent style="ButtonSoftEditFullWidth" onClick={this.setStateFn({ edit: true })}>
                  <Plus />
                </ButtonComponent>
              </div>
            </VBox>
          )}
          {this.state.edit ? this.renderEdit() : null}
        </Card>
      </Container>
    );
  }

  getParsedValue(name) {
    const parsedValue = parseFloat(this.getStatus(name));
    const value = isNaN(parsedValue) ? '0.00' : parsedValue?.toFixed(2);
    return value;
  }

  renderEdit() {
    console.dir(VEHICLE_EXTRA_COST);
    return (
      <ModalComponent onClose={this.reset.bind(this)} title={'Totaal extra kosten:    ' + formatCurrency(this.vehicle.extra_cost_sum || 0)}>
        <VBox>
          <VehiclePropertyLoadable name={'extra_cost_sum'} className={styles.loadableItem}>
            {/* <HBox vCenter className="sum">
              <div><h5><strong>{this.lbl('vehicle.property.extra_cost_sum')}</strong></h5></div>
              <div className="value" style={{ marginLeft: 'auto' }}>
              <h5> <strong>{formatCurrency(this.vehicle.extra_cost_sum || 0)}
                </strong></h5></div>
            </HBox> */}
          </VehiclePropertyLoadable>
          {this.vehicleExtraCost?.map(item => (
    item.isTitle ? (
        <h5 key={item.name}>{this.lbl(`vehicle.property.${item.name}`)}</h5>
    ) : (
        <VehiclePropertyLoadable key={item.name} name={item.name} className={styles.loadableItem}>
            {this.state.add == item.name ? (
                <VBox>
                    <HBox style={{marginLeft: "10px"}}vCenter className="gap-2">
                        <div className="label">{this.lbl(`vehicle.property.${item.name}`)} </div>
                        <div className={styles.buttonLabel}>
                            <div className={styles.labelCompany}>
                                <input
                                    className="form-control"
                                    number
                                    onChange={this.onInputChange.bind(this)}
                                    name="amount"
                                    value={this.state.amount}
                                />
                            </div>
                            <div className={styles.decoratorLabel}>
                                <Euro />
                            </div>
                        </div>
                        <ButtonComponent
                            style={'ButtonSoftEdit'}
                            size={'btn-sm'}
                            onClick={() => {
                                this.setState({ add: null });
                                this.toggle(item.name, parseFloat(this.state.amount)?.toFixed(2));
                            }}
                        >
                            <Check />
                        </ButtonComponent>
                        <ButtonComponent
                            style={'ButtonSoftDelete'}
                            size={'btn-sm'}
                            onClick={() => this.removeExtraCost(item.name)}
                        >
                            <Times />
                        </ButtonComponent>
                    </HBox>
                    {this.renderCostRemark(item?.name, 'add')}
                </VBox>
            ) : (
                <VBox>
                    <HBox vCenter>
                        <HBox
                            left
                            vCenter
                            style={{ width: '80%', marginLeft: '10px' }}
                            onClick={() => {
                                if (item.name == 'extra_costs_interest') {
                                    return;
                                }
                                this.setState({
                                  add: item.name,
                                  amount: item.amount || '1.00',
                                  newRemarkText: this.getRemarkText(item?.name),
                                });
                            }}
                        >
                            <CheckboxComponent checked={this.getStatus(item.name)} onChange={() => {}} />
                            <div className="label">{this.lbl(`vehicle.property.${item.name}`)}</div>
                        </HBox>
                        {this.getStatus(item.name) ? <div className="value">€ {this.getParsedValue(item?.name)}</div> : null}
                    </HBox>
                    {this.renderCostRemark(item?.name)}
                </VBox>
            )}

            </VehiclePropertyLoadable>
          )))}
        </VBox>
        <div className={styles.buttonFooter}>
          <ButtonComponent style="ButtonSoftPrimary" onClick={this.reset.bind(this)}>
            {this.lbl('ok')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }
}

VehicleExtraCostCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      REQUEST_USER,
      `${REQUEST_VEHICLE_PROPERTY_UPDATE}-extra_costs_remarks`,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
    ]),
    loggedUser: selectUser(ownProps?.loggedUserId),
    permissions: selectPermissions(),

  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    remove(name, callback) {
      dispatch(deleteVehicleProperty(ownProps.vehicle.id, name, callback));
    },
    add(name, value, callback) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, name, parseFloat(value), callback));
    },
    fetch() {
      dispatch(fetchUser(ownProps?.loggedUserId));
    },
    setRemark(dto, callback) {
      dispatch(setVehicleProperty(ownProps?.vehicle?.id, 'extra_costs_remarks', dto, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleExtraCostCard = compose(withConnect, withRouter)(VehicleExtraCostCardComp);
